export default __webpack_public_path__ + "assets/icon4-28e7061.svg";